module.exports = __webpack_public_path__ + "static/media/tagline-white.35c58e12.png";